<div class="wrapperSkeleton" [class.wrapperSkeleton--positionAbsolute]="positionAbsolute">
  <div *ngFor="let i of skeletonCountArray" class="skeletonRow">
    <div *ngIf="skeletonCircleVisible" class="skeletonCircle"></div>
    <div class="skeletonLine large"></div>
    <div *ngIf="skeletonExtraLineVisible" class="skeletonLine small"></div>
  </div>
</div>